import {
  Anchor,
  GridContainer,
  Heading,
  Button,
  GridItem,
} from '@enterprise-ui/canvas-ui-react'
import { DASHBOARD_PATH } from '../../constants'
import {
  POL_DEV_SUPPORT_LINK,
  POL_PROD_SUPPORT_LINK,
} from '../../config/appConfig'
import { isPOLDomain } from '../../common/helper'
import { StyledDashboardBodyLayout } from './styles'
import { Layout } from '@enterprise-ui/canvas-ui-react'
import { useEffect, useState } from 'react'
import Header from '../Header'
import apiConfig from '../../config/apiConfig'
/**
 * Component shown when component encountered errors
 */

interface Props {
  userDetails: Record<string, any>
}

const FallbackScreen = (props: Props) => {
  const { userDetails } = props
  const [supportURL, setSupportURL] = useState<string>('')

  const domain =
    apiConfig?.appEnv === 'prod' ? POL_PROD_SUPPORT_LINK : POL_DEV_SUPPORT_LINK

  const getRmsSupportCenterURL = () => {
    if (isPOLDomain(window.location.origin)) {
      return apiConfig?.roundelHelpCenterPolURL
    } else {
      return apiConfig?.roundelHelpCenterEnterpriseURL
    }
  }

  useEffect(() => {
    if (apiConfig && Object.keys(apiConfig).length > 1) {
      setSupportURL(
        `${getRmsSupportCenterURL()}${apiConfig?.supportURLs?.RMS?.ticket}`,
      )
    }
  }, [apiConfig])

  return (
    <Layout fullWidth={true} theme="roundel" darkMode={false}>
      <Header userDetails={userDetails} />
      <StyledDashboardBodyLayout includeRail={true} className="hc-pa-none">
        <div className="hc-pa-normal hc-pa-2x hc-mt-3x Roundel__Gradient--vertical-blue-purple hc-full-height-error">
          <GridContainer className="hc-pa-none">
            <GridItem xs={12}>
              <div className="wrapper">
                <Heading className="messageHeader">
                  Something went wrong!
                </Heading>
                <div className="hc-fs-md error-text">
                  <span>
                    If the error persists, please submit a support ticket for
                    assistance.
                  </span>
                </div>
                <Heading className="buttonContainer">
                  <Button
                    className="hc-mr-sm buttonSupport"
                    data-test="create-new-metric-btn"
                    type="secondary"
                  >
                    <Anchor
                      href={supportURL}
                      target="_blank"
                      data-test="POLSupportLink"
                    >
                      Submit Ticket
                    </Anchor>
                  </Button>
                  <Button
                    className="hc-mt-sm buttonLink"
                    data-test="create-new-metric-btn"
                    type="primary"
                  >
                    <Anchor href={DASHBOARD_PATH}>Back to Dashboard</Anchor>
                  </Button>
                </Heading>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </StyledDashboardBodyLayout>
    </Layout>
  )
}

export default FallbackScreen
